export const mapSetter = (state, setters = {}) => (
  Object.keys(state).reduce((acc, stateName) => {
    acc[stateName] = {
      get: state[stateName],
   }
   if (setters[stateName]) {
      acc[stateName].set = setters[stateName];
   }
   else {
     acc[stateName].set = function(value) {
        this.$store.state[stateName] = value
     }
   }
   return acc
 }, {})
)

export function autoMutations(module) {
  if(module.mutations === undefined) {
    module.mutations = {}
  }
  Object.keys(module.state).forEach(key => {
    if (module.mutations[key] === undefined) {
      module.mutations[key] = (state, value) => {
        state[key] = value
      }
    }
  })
  return module
}

export function autoGetters(module) {
  if (module.getters === undefined) {
    module.getters = {}
  }
  Object.keys(module.state).forEach(key => {
    if (module.getters[key] === undefined) {
      module.getters[key] = state => state[key]
    }
  })
  return module
}
